var _rect, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _defs12, _defs13, _defs14, _defs15, _defs16, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBack2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 450 900",
    width: 450,
    height: 900,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 450,
    height: 900,
    fill: "#FFFFFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#3c44fa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#3c44fa",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_1",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#3c44fa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#6c5dfc",
    stopOpacity: 1
  })))), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_2",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#8c77fd",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#6c5dfc",
    stopOpacity: 1
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_3",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#8c77fd",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#a891ff",
    stopOpacity: 1
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_4",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#c0acff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#a891ff",
    stopOpacity: 1
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_5",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#c0acff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#d6c7ff",
    stopOpacity: 1
  })))), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_6",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ebe3ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#d6c7ff",
    stopOpacity: 1
  })))), _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_7",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ebe3ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ffffff",
    stopOpacity: 1
  })))), _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#3c44fa",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#3c44fa",
    stopOpacity: 1
  })))), _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_1",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#6c5dfc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#3c44fa",
    stopOpacity: 1
  })))), _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_2",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#6c5dfc",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#8c77fd",
    stopOpacity: 1
  })))), _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_3",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#a891ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#8c77fd",
    stopOpacity: 1
  })))), _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_4",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#a891ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#c0acff",
    stopOpacity: 1
  })))), _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_5",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#d6c7ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#c0acff",
    stopOpacity: 1
  })))), _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_6",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#d6c7ff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ebe3ff",
    stopOpacity: 1
  })))), _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_7",
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffffff",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "70%",
    stopColor: "#ebe3ff",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(450, 900)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-382.5 0C-362.8 -42.8 -343.2 -85.5 -328.9 -136.2C-314.6 -187 -305.8 -245.6 -270.5 -270.5C-235.2 -295.3 -173.5 -286.3 -124 -299.3C-74.5 -312.4 -37.3 -347.4 0 -382.5L0 0Z",
    fill: "#f5f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-334.7 0C-317.5 -37.4 -300.3 -74.8 -287.8 -119.2C-275.3 -163.6 -267.5 -214.9 -236.7 -236.7C-205.8 -258.4 -151.8 -250.5 -108.5 -261.9C-65.2 -273.3 -32.6 -304 0 -334.7L0 0Z",
    fill: "#e1d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-286.9 0C-272.1 -32.1 -257.4 -64.1 -246.7 -102.2C-236 -140.2 -229.3 -184.2 -202.9 -202.9C-176.4 -221.5 -130.1 -214.7 -93 -224.5C-55.9 -234.3 -27.9 -260.6 0 -286.9L0 0Z",
    fill: "#cbbaff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-239.1 0C-226.8 -26.7 -214.5 -53.4 -205.6 -85.1C-196.6 -116.8 -191.1 -153.5 -169 -169C-147 -184.6 -108.4 -178.9 -77.5 -187.1C-46.6 -195.2 -23.3 -217.1 0 -239.1L0 0Z",
    fill: "#b49fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-191.2 0C-181.4 -21.4 -171.6 -42.8 -164.5 -68.1C-157.3 -93.5 -152.9 -122.8 -135.2 -135.2C-117.6 -147.7 -86.7 -143.2 -62 -149.7C-37.3 -156.2 -18.6 -173.7 0 -191.2L0 0Z",
    fill: "#9b84fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-143.4 0C-136.1 -16 -128.7 -32.1 -123.3 -51.1C-118 -70.1 -114.7 -92.1 -101.4 -101.4C-88.2 -110.7 -65.1 -107.4 -46.5 -112.3C-27.9 -117.1 -14 -130.3 0 -143.4L0 0Z",
    fill: "#7d6afd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-95.6 0C-90.7 -10.7 -85.8 -21.4 -82.2 -34.1C-78.7 -46.7 -76.4 -61.4 -67.6 -67.6C-58.8 -73.8 -43.4 -71.6 -31 -74.8C-18.6 -78.1 -9.3 -86.9 0 -95.6L0 0Z",
    fill: "#5751fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-47.8 0C-45.4 -5.3 -42.9 -10.7 -41.1 -17C-39.3 -23.4 -38.2 -30.7 -33.8 -33.8C-29.4 -36.9 -21.7 -35.8 -15.5 -37.4C-9.3 -39 -4.7 -43.4 0 -47.8L0 0Z",
    fill: "#3c44fa"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.5 0C377.5 49.6 372.5 99.3 353.4 146.4C334.2 193.5 300.9 238.1 258.8 258.8C216.7 279.5 165.9 276.2 121.3 292.9C76.7 309.5 38.4 346 0 382.5L0 0Z",
    fill: "#f5f1ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.7 0C330.3 43.4 326 86.8 309.2 128.1C292.4 169.3 263.3 208.4 226.5 226.5C189.6 244.6 145.2 241.7 106.1 256.3C67.1 270.8 33.6 302.7 0 334.7L0 0Z",
    fill: "#e1d5ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.9 0C283.1 37.2 279.4 74.4 265 109.8C250.7 145.1 225.7 178.6 194.1 194.1C162.5 209.6 124.4 207.2 91 219.7C57.5 232.1 28.8 259.5 0 286.9L0 0Z",
    fill: "#cbbaff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.1 0C236 31 232.8 62 220.9 91.5C208.9 120.9 188.1 148.8 161.8 161.8C135.5 174.7 103.7 172.7 75.8 183C48 193.4 24 216.2 0 239.1L0 0Z",
    fill: "#b49fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.3 0C188.8 24.8 186.3 49.6 176.7 73.2C167.1 96.7 150.4 119.1 129.4 129.4C108.4 139.7 83 138.1 60.7 146.4C38.4 154.7 19.2 173 0 191.3L0 0Z",
    fill: "#9b84fe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.4 0C141.6 18.6 139.7 37.2 132.5 54.9C125.3 72.6 112.8 89.3 97.1 97.1C81.3 104.8 62.2 103.6 45.5 109.8C28.8 116.1 14.4 129.7 0 143.4L0 0Z",
    fill: "#7d6afd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.6 0C94.4 12.4 93.1 24.8 88.3 36.6C83.6 48.4 75.2 59.5 64.7 64.7C54.2 69.9 41.5 69.1 30.3 73.2C19.2 77.4 9.6 86.5 0 95.6L0 0Z",
    fill: "#5751fb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8 0C47.2 6.2 46.6 12.4 44.2 18.3C41.8 24.2 37.6 29.8 32.4 32.4C27.1 34.9 20.7 34.5 15.2 36.6C9.6 38.7 4.8 43.2 0 47.8L0 0Z",
    fill: "#3c44fa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBack2);
export default __webpack_public_path__ + "static/media/back2.e7d7e908ac606079a84a5ccacb8ca1b5.svg";
export { ForwardRef as ReactComponent };